<template>
  <v-card-title class="d-flex justify-space-between">
    <h3 class="headline font-weight-bold">Notificaciones</h3>
    <v-chip small disabled>{{cantidad}}</v-chip>
  </v-card-title>
</template>

<script>
export default {
  name: "headerComponent",
  props :{
    cantidad:{
      type : Number,
      default : null
    }
  },
};
</script>